(function () {
  var FIELDS = 'title,product_type,variants.title,vendor,variants.sku,variants.barcode';
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var urlStr = typeof input === 'string' ? input : (input && input.url);
      if (urlStr && urlStr.indexOf('/search/suggest') !== -1) {
        var u = new URL(urlStr, window.location.origin);
        if (!u.searchParams.has('resources[options][fields]')) {
          u.searchParams.set('resources[options][fields]', FIELDS);
        }
        if (typeof input === 'string') {
          return origFetch.call(this, u.toString(), init);
        }
        return origFetch.call(this, new Request(u.toString(), input), init);
      }
    } catch (_) {}
    return origFetch.call(this, input, init);
  };
})();
